import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import "./style.css";
export const NavLogo = () => {
  return (
    <div className="logo flex ai-c">
      <Link to="/" className="link">
        <img src={logo} alt="logo" className="logo-img" />
      </Link>
      <div className="mx-1">
        <Link to="/" className="link logo-text">
          <h1>CSIT Mantra</h1>
        </Link>
        <p className="cursive text-center text-slogan">"Learn and Grow"</p>
      </div>
    </div>
  );
};
